jQuery(document).ready(function($) {


	$(document).on('click','.btn-favoritar', function(event) {

		var btn = $(this).html();
		var that = this;

		$(that).find('i.fa').removeClass('fa-heart fa-heart-o').addClass('fa-spin fa-spinner');

		$.ajax({
			url: that.getAttribute('data-href'),
			type: 'POST',
			data: {
				id: that.getAttribute('data-id'),
				value: that.getAttribute('data-value'),
			},
		})
		.done(function(response) {
			if (that.getAttribute('data-value') == 1) {
				$(that).addClass('active');
				$(that).find('i.fa').removeClass('fa-spin fa-spinner').addClass('fa-heart');

				$(that).animate({
					scale: 1.5,
				}, 200, function(){
					$(that).animate({
						scale: 0.9,
					}, 200, function(){
						$(that).animate({
							scale: 1.1,
						}, 200, function(){
							$(that).animate({
								scale: 0.9,
							}, 200, function(){
								$(that).animate({
									scale: 1,
								}, 200, function(){
									
								})
							})
						});
					})
				});

				var total = $('.favorito-count').html();
				$('.favorito-count').html(parseInt(total)+1);

				if ($('#favorito-container-topo')[0] && $('#favorito-container-topo .favorito-imovel').length < 3) {
					montarFavoritoTopo(response.imovel);
					montarFavoritoMobile(response.imovel);
				}
			}
			else {
				if ($('.conta-favoritos-route')[0]) 
					$(that).closest('.imovel').removerElemento();

				var total = $('.favorito-count').html();
				$('.favorito-count').html(parseInt(total)-1);
				if ($('#favorito-imovel-'+that.getAttribute('data-id'))[0])
					$('#favorito-imovel-'+that.getAttribute('data-id')).remove();

				$(that).removeClass('active');
				$(that).find('i.fa').removeClass('fa-spin fa-spinner').addClass('fa-heart-o');

				var total = parseInt($('.favorito-count').html());
		
				if (total == 0) {
					if ($('#nenhum-favorito-topo')[0]) {
						$('#nenhum-favorito-topo').css('display', 'block');
					}

					var btVerTodos = document.getElementById('bt-favorito-ver-todos-topo');
			
					if (btVerTodos) {
						btVerTodos.style.display = 'none';
					}

					var btVerTodosMobile = document.getElementById('bt-favorito-ver-todos-mobile');
			
					if (btVerTodosMobile) {
						btVerTodosMobile.style.display = 'none';
					}
				}

				if ($('#favorito-mobile-'+that.getAttribute('data-id'))[0]) {
					$('#favorito-mobile-'+that.getAttribute('data-id')).remove();
				}

			}
			
			$(that).attr('title', that.getAttribute('data-value')==0 ? 'Adicionar aos favoritos' : 'Remover aos favoritos');

			$(that).attr('data-value', that.getAttribute('data-value') == 1 ? 0 : 1);

		});
		
	});
	
	function montarFavoritoTopo(imovel) {
		if ($('#nenhum-favorito-topo')[0]) {
			$('#nenhum-favorito-topo').css('display', 'none');
		}

		var btVerTodos = document.getElementById('bt-favorito-ver-todos-topo');

		if (btVerTodos) {
			btVerTodos.style.display = 'block';
		}

		var divFavorito = document.createElement('div');
		divFavorito.id = 'favorito-imovel-' + imovel.id;
		divFavorito.classList.add("favorito-imovel");

		var divImagem = document.createElement('div');
		divImagem.classList.add("imagem");

		var linkImagem = document.createElement('a');
		linkImagem.href = imovel.url_favorito;
		linkImagem.onclick = function () {
			if (ga) {
				// ga('send', 'event', 'CliqueFavoritoTopo');
			}
		}		

		var imagemTag = document.createElement('img');
		imagemTag.src = imovel.imagem;
		imagemTag.alt = imovel.alt_imagem;
		imagemTag.width = 70;
		imagemTag.height = 70;

		var divInfo = document.createElement('div');
		divInfo.classList.add('info');

		var divTitulo = document.createElement('div');
		divTitulo.classList.add('titulo');

		var linkTitulo = document.createElement('a');
		linkTitulo.href = imovel.url_favorito;
		linkTitulo.innerHTML = imovel.titulo;
		linkTitulo.onclick = function () {
			if (ga) {
				// ga('send', 'event', 'CliqueFavoritoTopo');
			}
		}

		var divExtra = document.createElement('div');
		divExtra.classList.add("extra");
		divExtra.innerHTML = imovel.extra;

		var divPreco = document.createElement('div');
		divPreco.classList.add("preco", "fleft");
		divPreco.innerHTML = imovel.valor;

		var divBtVerImovel = document.createElement('div');
		divBtVerImovel.classList.add('fright');

		var linkBtVerImovel = document.createElement('a');
		linkBtVerImovel.href = imovel.url_favorito;
		linkBtVerImovel.classList.add('btn', 'btn-green', 'btn-xsm', 'btn-shadow');
		linkBtVerImovel.innerHTML = 'Ver imóvel';
		linkBtVerImovel.onclick = function () {
			if (ga) {
				// ga('send', 'event', 'CliqueFavoritoTopo');
			}
		}

		divBtVerImovel.append(linkBtVerImovel);

		var divClearFix = document.createElement('div');
		divClearFix.classList.add("clearfix");

		linkImagem.append(imagemTag);
		divImagem.append(linkImagem);
		divFavorito.append(divImagem);
		divTitulo.append(linkTitulo);
		divInfo.append(divTitulo);
		divInfo.append(divExtra);
		divFavorito.append(divInfo);
		divInfo.append(divPreco);
		divInfo.append(divBtVerImovel);
		divInfo.append(divClearFix);

		$('#favorito-container-topo').append(divFavorito);
	}

	function montarFavoritoMobile(imovel) {
		var divContainer = document.createElement('div');
		divContainer.classList.add('favorito-imovel');
		divContainer.id = 'favorito-mobile-' + imovel.id;

		var divTitulo = document.createElement('div');
		divTitulo.classList.add('titulo');

		var linkTitulo = document.createElement('a');
		linkTitulo.href = imovel.url_favorito;
		linkTitulo.innerHTML = imovel.titulo;
		linkTitulo.onclick = function () {
			if (ga) {
				// ga('send', 'event', 'CliqueFavoritoTopo');
			}
		}

		var divExtra = document.createElement('div');
		divExtra.classList.add('extra');

		var linkExtra = document.createElement('a');
		linkExtra.href = imovel.url_favorito;
		linkExtra.innerHTML = imovel.extra;
		linkExtra.onclick = function () {
			if (ga) {
				// ga('send', 'event', 'CliqueFavoritoTopo');
			}
		}

		var divPreco = document.createElement('div');
		divPreco.classList.add('preco', 'fleft');
		divPreco.innerHTML = imovel.valor;

		var divClear = document.createElement('div');
		divClear.classList.add('clearfix');

		divExtra.append(linkExtra);
		divTitulo.append(linkTitulo);
		divContainer.append(linkTitulo);
		divContainer.append(divExtra);
		divContainer.append(divPreco);
		divContainer.append(divClear);

		var btVerTodos = document.getElementById('bt-favorito-ver-todos-mobile');

		if (btVerTodos) {
			btVerTodos.style.display = 'block';
		}

		$('#favorito-container-mobile').append(divContainer);
	}

});